module.exports = __webpack_public_path__ + "img/LV2.fe192bd1.webp";